'use strict';
function sortByHour(a, b) {
  return a.hora > b.hora ? 1 : -1;
}

function checkIfDateIsToday(prDate) {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  prDate = new Date(prDate.split('-').join('/'));
  prDate.setHours(0, 0, 0, 0);

  if (date.getTime() == prDate.getTime()) return true;
  return false;
}

//Recupera a primeira sessão considerando as salas dos filmes
function getFirstSession(prRooms) {
  const sessions = [];

  prRooms.forEach(e => {
    if (e.sessoes && e.sessoes.length > 0) {
      const session = new Object();
      const s = e.sessoes[0];

      session.sala = e.nome;

      session.dataHora = s.horario.dataHora;
      session.hora = s.horario.hora;
      session.diaMes = s.horario.diaMes;
      session.urlCompra = s.urlCompra;
      session.tipos = s.tipos;

      sessions.push(session);
    }
  });
  sessions.sort(sortByHour);

  if (sessions.length > 0) return sessions[0];
  else return null;
}

function getPreSaleDateHTML(preSaleFirstSession) {
  let movieType;
  let lblText;

  if (preSaleFirstSession) movieType = preSaleFirstSession.tipoFilme;

  if (movieType == PRE_ESTREIA) lblText = 'Pré estreia em ' + preSaleFirstSession.diaMes;
  else if (movieType == ESTREIA) lblText = 'Estreia em ' + preSaleFirstSession.diaMes;
  else if (movieType == SESSAO_UNICA) lblText = 'Sessão em ' + preSaleFirstSession.diaMes;
  else lblText = '';

  if (preSaleFirstSession) {
    return (
      '<div class="cinema-list__debut cinema-debut section-day">' +
      '<img src="/lumis-theme/br/com/aliansce/shoppings/theme/shoppings-aliansce/assets/images/icons/icon-horario.svg" onload="SVGInject(this)" class="img-svg-color">' +
      '<span class="cinema-debut__text">' +
      lblText +
      '</span>' +
      '</div>'
    );
  }

  return '';
}

function getNextSessionHTML(nextSession, date, emPreVenda) {
  let lblText;
  let nextSessionHTML;

  if (emPreVenda) {
    lblText = 'Pré venda';

    nextSessionHTML =
      '<div class="cinema-list__next-session next-session">' +
      '<div class="cinema-list__section pre-venda">' +
      lblText +
      '</div>';
  } else {
    const ehHoje = checkIfDateIsToday(date);

    if (ehHoje) {
      lblText = 'Próxima sessão';
    } else {
      lblText = 'Primeira sessão';
    }
    nextSessionHTML =
      '<div class="cinema-list__section">' +
      lblText +
      '</div>' +
      '<div class="cinema-list__next-session next-session">';
  }

  if (nextSession) nextSessionHTML += getSessionHTML(nextSession);
  else nextSessionHTML += '<p>Não há mais sessões disponíveis.</p>';

  nextSessionHTML += '</div>';

  return nextSessionHTML;
}

function getOtherSessionsHTML(movie, isPreSaleList, fGetTypes) {
  let otherSessionsHTML = '';
  const popupFiltersHTML = '';

  if (movie.exibicoes && movie.exibicoes.length > 0) {
    otherSessionsHTML =
      '        <div class="combo">' + getOtherSessions(movie.exibicoes[0].salas) + '        </div>';
  }

  return otherSessionsHTML;
}

function getOtherSessions(rooms) {
  const sessions = getSortSessionsByRooms(rooms);

  let otherSessions = '';
  if (sessions.length > 1) {
    otherSessions +=
      '<button class="combo__btn" type="button">Outros horários do dia</button>' +
      '<div class="combo__content">';
    for (let i = 1; i < sessions.length; i++) {
      otherSessions +=
        '<div class="cinema-list__next-session next-session">' +
        getSessionHTML(sessions[i]) +
        '		     </div>';
    }
    otherSessions += '</div>';
  }
  return otherSessions;
}

function getSessionHTML(session) {
  var session = session ? session : '';
  let sessionHTML = '';
  if (session) {
    sessionHTML =
      '<div class="cinema-list__holder">' +
      '	<span class="next-session__info">' +
      session.sala +
      '       <span class="next-session__hour">' +
      session.hora +
      'H</span>' +
      '<div class="cinema-list__buy-ticket">' +
      '       <a target="_blank" onclick="dataLayerClique(\'agendar_cinema\', $(this).parents(\'#filmeInfo\').find(\'h3\').text())" class="button_hollow-green callModalBuy" href="' +
      session.urlCompra +
      '">Comprar</a>' +
      '</div>' +
      '    </span>' +
      getTypes(session, true) +
      '</div>';
  }

  return sessionHTML;
}

function getSortSessionsByRooms(rooms) {
  const sessions = [];
  if (rooms) {
    rooms.forEach(e => {
      const nomeSala = e.nome;
      e.sessoes.forEach(e => {
        const session = new Object();
        session.sala = nomeSala;
        session.hora = e.horario.hora;
        session.urlCompra = e.urlCompra;
        session.tipos = e.tipos;
        session.dataHora = e.horario.dataHora;
        session.diaMes = e.horario.diaMes;
        sessions.push(session);
      });
    });
    sessions.sort(sortByHour);
  }
  return sessions;
}

function getSessionGroups(exhibitions, movieId, fGetTypes) {
  let sessionGroups = '';

  if (exhibitions) {
    $(exhibitions).each((i, data) => {
      const formattedDate = data.dataFormatada.replace('/', '-');
      if (data.salas) {
        const sessions = getSortSessionsByRooms(data.salas);

        sessionGroups +=
          '<div class="cinema-list__next-session next-session session--wrapper--' +
          movieId +
          '--' +
          formattedDate +
          '">';

        if (sessions.length > 0) {
          $(sessions).each((i, session) => {
            sessionGroups += getSessionHTML(session);
          });
        } else {
          sessionGroups += '<p>Não há sessões disponíveis para este dia.</p>';
        }

        sessionGroups += '</div>';
      }
    });
  }
  return sessionGroups;
}

function hasSessions(exibicoes) {
  let hasSessions = false;
  if (exibicoes) {
    $(exibicoes).each((i, exibicao) => {
      if (exibicao.salas) {
        $(exibicao.salas).each((i, sala) => {
          const sessoes = sala.sessoes;
          if (sessoes && sessoes.length > 0) hasSessions = true;
        });
      }
    });
  }
  return hasSessions;
}

function getPopupFiltersItens(prMovie) {
  let filtersHTML = '';

  if (prMovie.exibicoes && prMovie.exibicoes.length > 0) {
    $(prMovie.exibicoes).each((i, e) => {
      if (i < 7) {
        let flag = '';

        if (prMovie.tipo == PRE_ESTREIA && i == 0)
          flag = '<label class="cinema-dates__label">Pré Estreia</label>';
        else if ((prMovie.tipo == PRE_ESTREIA && i == 1) || (prMovie.tipo == ESTREIA && i == 0))
          flag = '<label class="cinema-dates__label">Estreia</label>';

        filtersHTML +=
          '<li class="cinema-dates__item">' +
          '<a class="cinema-dates__link cinema-dates__presale-sessions" id="session--wrapper--' +
          prMovie.id +
          '--' +
          e.dataFormatada.replace('/', '-') +
          '" href="javascript:void(0)">' +
          '<span class="cinema-dates__day">' +
          e.diaSemana +
          '</span>' +
          '<span class="cinema-dates__date">' +
          e.dataFormatada +
          '</span>' +
          flag +
          '</a>' +
          '</li>';
      }
    });
  }

  return filtersHTML;
}

function getFilterByDay(moviesPerDayJSON) {
  const newDay = [];
  let weekDay = '';

  const formattedDate = moviesPerDayJSON.dataFormatada.replace('/', '-');
  weekDay = checkIfDateIsToday(moviesPerDayJSON.data)
    ? 'Hoje'
    : moviesPerDayJSON.diaSemana.charAt(0).toUpperCase() +
      moviesPerDayJSON.diaSemana.slice(1, 3).toLowerCase();

  newDay.push(
    '<li class="cinema-dates__item">' +
      '<a class="cinema-dates__link filtroMovies" id="movies--' +
      formattedDate +
      '" href="javascript:void(0)">' +
      '<span class="cinema-dates__day">' +
      weekDay +
      '</span>' +
      '<span class="cinema-dates__date">' +
      moviesPerDayJSON.dataFormatada +
      '</span>' +
      '</a>' +
      '</li>'
  );

  return newDay.join('');
}

function getGeneros(movie) {
  let generos = '';

  for (let i = 0; i < movie.generos.length; i++) {
    generos += '<span class="card__type">' + movie.generos[i] + '</span>';

    if (i != movie.generos.length - 1) generos += ' - ';
  }

  return generos;
}

function youtubeLink_onDemand(movieId, movieDate) {
  const $iframeLink = $('#iframe' + movieId + movieDate);

  if ($iframeLink.attr('data-src') != undefined)
    $iframeLink.attr('src', $iframeLink.attr('data-src'));
}

function initPopup() {
  if ($('.button--popup').length > 0) {
    $('.button--popup').magnificPopup({
      type: 'inline',
      fixedContentPos: true,
      midClick: true,
    });
    $('.button--close').on('click', () => {
      $.magnificPopup.close();
    });
  }
}

//TIPOS PRE VENDA
const PRE_ESTREIA = 'PRE_ESTREIA';
const ESTREIA = 'ESTREIA';
const SESSAO_UNICA = 'SESSAO_UNICA';
const SEM_SESSAO = 'SEM_SESSAO';
const EM_CARTAZ = 'EM_CARTAZ';
/*
	REGRAS
	Tem apenas uma sessão -> 'Sessão em'
	Não tem nenhuma sessão -> 'Não há sessões disponíveis' (filme indisponível)
	Tem mais de uma sessão ->  
		Tem campo estreia ->
			Data de estréia maior que a da primeira sessão -> 'Pré estréia em <data-primeira-sessao> ' e 'Estreia em <próxima-data-com-sessão>'
			Data de estréia menor ou igual que a da primeira sessão -> 'Estreia em <data-estreia>'
		Não tem campo estreia -> 'Estreia em <data-primeira-sessao>'
	*/
function createMovieObject(prMovie, prDate, prFormattedDate, prWeekDay) {
  const movie = {};
  let primeiraSessao;
  let primeiraSessaoDataHora;

  if (prMovie.salas && prMovie.salas.length > 0) primeiraSessao = getFirstSession(prMovie.salas);

  if (primeiraSessao) primeiraSessaoDataHora = primeiraSessao.dataHora;

  if (prMovie.estreia) movie.estreia = prMovie.estreia.dataHora;

  if (!primeiraSessaoDataHora && !movie.estreia) return null;

  movie.id = prMovie.id;
  movie.titulo = prMovie.titulo;
  movie.duracao = prMovie.duracao;
  movie.classificacaoEtaria = prMovie.classificacaoEtaria;
  movie.urlFilme = prMovie.urlFilme;
  movie.urlFilmeCinema = prMovie.urlFilmeCinema;
  movie.sinopse = prMovie.sinopse ? prMovie.sinopse : 'Sinopse não disponível';
  movie.emPreVenda = prMovie.emPreVenda;

  if (movie.emPreVenda) {
    if (
      prMovie.salas &&
      prMovie.salas.length > 0 &&
      prMovie.salas[0].sessoes &&
      prMovie.salas[0].sessoes.length > 0
    ) {
      if (prMovie.salas.length == 1 && prMovie.salas[0].sessoes.length == 1)
        movie.tipo = SESSAO_UNICA;
      else if (movie.estreia) {
        if (primeiraSessaoDataHora) {
          if (new Date(movie.estreia) > new Date(primeiraSessaoDataHora)) movie.tipo = PRE_ESTREIA;
          else movie.tipo = ESTREIA;
          movie.estreia = primeiraSessaoDataHora;
        } else movie.tipo = ESTREIA;
      } else {
        movie.tipo = ESTREIA;
        movie.estreia = primeiraSessaoDataHora;
      }
    } else movie.tipo = SEM_SESSAO;
  } else movie.tipo = EM_CARTAZ;

  if (primeiraSessao) {
    primeiraSessao.tipoFilme = movie.tipo;
    movie.primeiraSessao = primeiraSessao;
  }

  if (prMovie.imagens && prMovie.imagens.length > 0) movie.imagem = prMovie.imagens[0].url;
  else
    movie.imagem =
      '/lumis-theme/br/com/shoppings/aliansce/theme/shopping-leblon/img/contents/movie-default.jpg';

  if (prMovie.trailers && prMovie.trailers.length > 0)
    movie.trailer = prMovie.trailers[0].urlEmbutida;

  movie.generos = prMovie.generos;

  if (prMovie.salas && prDate && prFormattedDate && prWeekDay) {
    const ehHoje = checkIfDateIsToday(prDate);
    const weekDay = ehHoje ? 'Hoje' : prWeekDay.slice(0, 3);
    movie.exibicoes = [
      { data: prDate, dataFormatada: prFormattedDate, diaSemana: weekDay, salas: prMovie.salas },
    ];
  }
  return movie;
}

function putMovieOnList(prMovie, prDate, prFormattedDate, prWeekDay, movieList) {
  if (movieList.length > 0) {
    const index = movieList.findIndex(item => item.id == prMovie.id);
    if (index > -1) {
      const ehHoje = checkIfDateIsToday(prDate);
      const weekDay = ehHoje ? 'Hoje' : prWeekDay.slice(0, 3);
      const sala = {
        data: prDate,
        dataFormatada: prFormattedDate,
        diaSemana: weekDay,
        salas: prMovie.salas,
      };
      movieList[index].exibicoes.push(sala);
    } else {
      const movie = createMovieObject(prMovie, prDate, prFormattedDate, prWeekDay);
      if (movie) movieList.push(movie);
    }
  } else {
    const movie = createMovieObject(prMovie, prDate, prFormattedDate, prWeekDay);
    if (movie) movieList.push(movie);
  }

  return movieList;
}

function getMovieTypeFlag(movieType) {
  let flag;

  switch (movieType) {
    case PRE_ESTREIA:
      flag = 'PRÉ ESTREIA';
      break;
    case ESTREIA:
      flag = 'ESTREIA';
      break;
    case SESSAO_UNICA:
      flag = 'SESSÃO';
      break;
    case SEM_SESSAO:
      flag = 'NÃO HÁ SESSÕES';
      break;
    default:
      return '';
  }

  return (
    '<div class="movie__coming">' +
    '<span class="movie__coming__label">' +
    flag +
    '</span>' +
    '</div>'
  );
}
